module.exports = __webpack_public_path__ + "img/keder_tieforange_ral2011.d2468109.jpg";